import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { set_showRecording } from "../../actions/common";

class Recording extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: this.props.showModal,
      recordingUrl: this.props.recordingUrl
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.showRecording !== nextProps.showRecording) {
      this.setState({ show: nextProps.showRecording });
    }
    if (this.props.recordingUrl !== nextProps.recordingUrl) {
      this.setState({ recordingUrl: nextProps.recordingUrl });
    }
  }

  close = (key) => {
    this.props.handleClose(key);
  };

  render() {
    const { translations, selectedLanguage } = this.props;
    return (
      <Modal show={this.props.showModal} onHide={() => this.close("showModal")}>
        <Modal.Header
          className={`modal-content${this.props.theme} modal-header${this.props.theme}`}
          closeButton
        >
          <Modal.Title>{translations.recording[selectedLanguage]}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={`modal-content${this.props.theme}`}>
          {this.props.recordingUrl ? (
            <audio controls controlsList="nodownload">
              <source src={this.state.recordingUrl} type="audio/ogg" />
            </audio>
          ) : (
            translations.noRecording[selectedLanguage]
          )}
        </Modal.Body>
        <Modal.Footer className={`modal-content${this.props.theme}`}>
          <button
            type="button"
            onClick={() => this.close("showModal")}
            className={`btn-link modal-action${this.props.theme}`}
            style={{ width: "100%" }}
            data-dismiss="modal"
          >
            {translations.close[selectedLanguage]}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    logo: state.common.logo,
    translations: state.languages.translations,
    selectedLanguage: state.languages.selectedLanguage,
    theme: state.common.theme,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ set_showRecording }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Recording);



// WEBPACK FOOTER //
// ./src/agent/modals/Recording.js